import { createVNode as n, mergeProps as l } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DeleteTwoTone.js";
import s from "../components/PfIcon.js";
const e = (o, t) => {
  const r = {
    ...o,
    ...t.attrs
  };
  return n(s, l(r, {
    icon: m
  }), null);
};
e.displayName = "DeleteTwoTone";
e.inheritAttrs = !1;
export {
  e as default
};
